// Excel şablon indir + toplu yükleme
import { useRef, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { FileSpreadsheet, Upload } from 'lucide-react';
import { API, errText } from './storeShared';

export const StoreExcelButtons = ({ onImported }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);
  const template = async () => {
    const r = await axios.get(`${API}/stores/excel-template`, { responseType: 'blob' });
    const href = URL.createObjectURL(r.data);
    Object.assign(document.createElement('a'), { href, download: 'magaza_sablonu.xlsx' }).click();
    URL.revokeObjectURL(href);
  };
  const upload = async (file) => {
    if (!file) return;
    const fd = new FormData();
    fd.append('file', file);
    setBusy(true);
    try { const r = (await axios.post(`${API}/stores/excel-import`, fd)).data; setResult(r); onImported(); } catch (e) { toast.error(errText(e)); } finally { setBusy(false); ref.current.value = ''; }
  };
  return (
    <>
      <Button variant="outline" onClick={template} data-testid="store-excel-template-btn"><FileSpreadsheet className="h-4 w-4 mr-1 text-emerald-600" />Excel Şablonu</Button>
      <Button variant="outline" disabled={busy} onClick={() => ref.current.click()} data-testid="store-excel-import-btn"><Upload className="h-4 w-4 mr-1" />{busy ? 'Yükleniyor...' : 'Excel ile Yükle'}</Button>
      <input ref={ref} type="file" accept=".xlsx" className="hidden" onChange={(e) => upload(e.target.files?.[0])} data-testid="store-excel-input" />
      <Dialog open={!!result} onOpenChange={(o) => !o && setResult(null)}>
        <DialogContent className="max-w-lg" data-testid="store-excel-result">
          <DialogHeader><DialogTitle>Excel Yükleme Sonucu</DialogTitle></DialogHeader>
          <p className="text-sm"><b className="text-emerald-700">{result?.created}</b> yeni mağaza eklendi, <b className="text-sky-700">{result?.updated}</b> mağaza güncellendi.</p>
          {result?.errors?.length > 0 && (
            <div className="max-h-64 overflow-y-auto rounded-lg border border-rose-200 bg-rose-50 p-3 text-sm text-rose-800">
              <p className="mb-1 font-semibold">{result.errors.length} satır atlandı:</p>
              {result.errors.map(e => <p key={e.row}>Satır {e.row}: {e.msg}</p>)}
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
